<template>
    <div class="small-screen-nag">
        <Modal v-model="show">
            <template #body>
                <div class="body-text">
                    <div class="message message-portrait">
                        Your device is in portrait mode. Please rotate your device so that it is landscape mode.
                    </div>
                    <div class="message message-landscape">
                        The screen resolution on this device is too low for the application experience. Please try again
                        with another device (tablet or desktop computer).
                    </div>
                    <div class="message message-desktop">
                        The screen resolution is too low for the application experience. Please try making the window
                        bigger.
                    </div>
                </div>
            </template>

            <template #footer>
                <div class="text-right">
                    <button class="dismiss-button" @click="close">Dismiss</button>
                </div>
            </template>
        </Modal>
    </div>
</template>


<script>
    import Modal from "@/components/modal/Modal"

    export default {
        components: {
            Modal,
        },

        data() {
            return {
                show: true,
            }
        },

        methods: {
            close() {
                this.show = false
            },
        },
    }
</script>

<style lang="scss" scoped>
    .small-screen-nag {
        display: none;

        .message {
            display: none;
        }


        @media (orientation: portrait) and (hover: none) {
            .message.message-portrait {
                display: block;
            }
        }

        @media (orientation: landscape) and (hover: none) {
            .message.message-landscape {
                display: block;
            }
        }

        @media not all and (hover: none) {
            .message.message-desktop {
                display: block;
            }
        }

        .dismiss-button {
            font-size: to_rem(18px);
            color: $secondary-color;
        }

    }

    .v-application {
        &.session-valid {
            .small-screen-nag {
                @media #{map-get($display-breakpoints, "sm-and-down")} {
                    display: block;
                }
            }
        }
    }
</style>
